import { Box, BoxProps } from "@chakra-ui/react";

function ResourcesIcon({
  color = "#0D0D0D",
  ...props
}: BoxProps & { color?: string }) {
  return (
    <Box {...props}>
      <svg
        width="25"
        height="25"
        viewBox="0 0 25 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M16.5 17.5L9.5 17.5"
          stroke={color}
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M16.5 13.5L13.5 13.5"
          stroke={color}
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M21 14.5C21 18.2712 21 20.1569 19.7552 21.3284C18.5104 22.5 16.5069 22.5 12.5 22.5H11.7273C8.46607 22.5 6.83546 22.5 5.70307 21.7022C5.37862 21.4736 5.09058 21.2025 4.8477 20.8971C4 19.8313 4 18.2966 4 15.2273V12.6818C4 9.71865 4 8.23706 4.46894 7.05375C5.22281 5.15142 6.81714 3.65088 8.83836 2.94135C10.0956 2.5 11.6698 2.5 14.8182 2.5C16.6173 2.5 17.5168 2.5 18.2352 2.7522C19.3902 3.15765 20.3012 4.0151 20.732 5.10214C21 5.77832 21 6.62494 21 8.31818V14.5Z"
          stroke={color}
          stroke-width="1.5"
          stroke-linejoin="round"
        />
        <path
          d="M4 12.5C4 10.6591 5.49238 9.16667 7.33333 9.16667C7.99912 9.16667 8.78404 9.28333 9.43137 9.10988C10.0065 8.95576 10.4558 8.50652 10.6099 7.93136C10.7833 7.28404 10.6667 6.49912 10.6667 5.83333C10.6667 3.99238 12.1591 2.5 14 2.5"
          stroke={color}
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </Box>
  );
}

export { ResourcesIcon };
